import { render, staticRenderFns } from "./TaskMemberDrawer.vue?vue&type=template&id=7bb8459b&scoped=true"
import script from "./TaskMemberDrawer.vue?vue&type=script&lang=js"
export * from "./TaskMemberDrawer.vue?vue&type=script&lang=js"
import style0 from "./TaskMemberDrawer.vue?vue&type=style&index=0&id=7bb8459b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8459b",
  null
  
)

export default component.exports